import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase";
import { Category } from "@/types";

type CategoriesState = Record<string, Category>

const initialState: CategoriesState = {}

export const fetchCategories = createAsyncThunk(
    "categories/fetchCategories",
    async () => {
        try {
            const collectionRef = collection(db, 'categories');
            const categories = await getDocs(collectionRef)
                .then((querySnapshot) => {
                    return querySnapshot.docs.reduce((acc, doc) => {
                        return {...acc, [doc.id]: {...doc.data(), id: doc.id}}
                    }, [] as Category[])
                })
                return categories;
        } catch (error) {
            console.error(error)
        }
    }
  );


const categoriesSlice = createSlice({
    name: "categories",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCategories.fulfilled, (state, action: PayloadAction<Category | undefined>) => {
            if (action.payload)  {
                return action.payload;
            }
            return state
        })
    }
})


export const categoriesSelector = (state: CategoriesState) => {
    return state.categories;
}

export default categoriesSlice.reducer